import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_usr_full",
  "use": "icon-i_usr_full-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_usr_full\"><title>icon_画板</title><path d=\"M16.73,3.94a6.59,6.59,0,0,1,6.65,6.53,6.65,6.65,0,0,1-13.3,0,6.59,6.59,0,0,1,6.65-6.53Zm0,0a6.59,6.59,0,0,1,6.65,6.53,6.65,6.65,0,0,1-13.3,0,6.59,6.59,0,0,1,6.65-6.53ZM14.24,19.19h5.54a8.52,8.52,0,0,1,8.59,8.44v.54c0,1.84-3.85,1.91-8.59,1.91H14.24c-4.75,0-8.59,0-8.59-1.91v-.54a8.51,8.51,0,0,1,8.59-8.44Zm0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol